import { makeObservable, observable, action } from 'mobx';

import { RootStore } from '.';

/**
 * Hub reachability, written only by the launcher socket. The hub is optional: the game runs on its own
 * socket to slot-lines, so a hub that is down degrades silently and never interrupts the player.
 */
export class HubStore {

  private rootStore: RootStore;

  /**
   * Live reachability. Deliberately not rendered anywhere: an outage the player cannot act on, in an
   * optional subsystem that recovers on its own, is not worth a message. Kept because it is what
   * latches `everConnected`, and because in-place staleness would read it rather than a global notice.
   */
  public connected = true;

  /**
   * Latched on the first authenticated connect. Widgets key off this: a hub that never came up hides
   * them, but once they have real data a mid-session drop leaves them on screen.
   */
  public everConnected = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      connected: observable,
      everConnected: observable,
      setConnected: action.bound
    });
  }

  public setConnected(value: boolean): void {
    this.connected = value;
    // A15 returns before the success path, so an anonymous socket never latches this.
    if (value) this.everConnected = true;
  }

}
